export const sitesForCompany = (sites, companyId) => {
  if (!companyId) return []
  return sites.filter((site) => site.company_id === companyId)
}

export const posForSite = (posList, siteId) => {
  if (!siteId) return []
  return posList.filter((pos) => pos.site_id === siteId)
}

export const posForCompany = (posList, sites, companyId) => {
  const siteIds = new Set(sitesForCompany(sites, companyId).map((site) => site.site_id))
  return posList.filter((pos) => siteIds.has(pos.site_id))
}

export const formatScopedPosLabel = (pos, sites, includeSite) => {
  const posLabel = pos.pos_label || pos.pos_serial || '-'
  if (!includeSite) return posLabel
  const siteName = pos.site_name || sites.find((site) => site.site_id === pos.site_id)?.name
  return siteName ? `${posLabel} (${siteName})` : posLabel
}

export const matchesExportScope = (artifact, siteIds = [], posIds = [], posOptions = []) => {
  const selectedSiteIds = Array.isArray(siteIds) ? siteIds : (siteIds ? [siteIds] : [])
  if (selectedSiteIds.length && artifact.site_id && !selectedSiteIds.includes(artifact.site_id)) return false
  if (!posIds.length) return true
  const selectedPosSiteIds = new Set(
    posOptions
      .filter((pos) => posIds.includes(pos.pos_id))
      .map((pos) => pos.site_id)
      .filter(Boolean)
  )
  if (artifact.site_id && !selectedPosSiteIds.has(artifact.site_id)) return false
  return !artifact.pos_id || posIds.includes(artifact.pos_id)
}
